<template>
  <div class="cdb-warp">
    <div class="home-warp">
      <img class="home-logo" src="../../assets/imgs/logo.png" alt="" />
      <h2 class="home-title">RENT A POWER BANK</h2>
      <p class="home-title-des">Stay charged, Stay Connected!</p>
      <div class="login-btn">
        <login-google @success="loadUser">
          <div class="btn googleloginbtn2">
            <img src="@/assets/imgs/icon_google.png" alt="" />
            <span>Sign in with Google</span>
            <div id="buttonDiv" class="google-login"></div>
          </div>
        </login-google>
        <login-apple v-if="system === 'ios'" @success="loadUser()">
          <button class="btn appleloginbtn2" id="sign-in-with-apple-button">
            <img src="@/assets/imgs/icon_apple.png" alt="" />
            <span>Sign in with Apple</span>
          </button>
        </login-apple>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { USER_INFO } from "@/apis/user";
import loginMixin from "@/mixins/login";
import { LoginGoogle, LoginApple } from "@/components/login";
export default {
  mixins: [loginMixin],
  components: {
    LoginGoogle,
    LoginApple
  },
  computed: {
    ...mapState(["user", "token", "system"]),
    i18n() {
      return this.$t("selectpackage");
    },
    i18nHome() {
      return this.$t("home");
    },
    i18nMine() {
      return this.$t("mine");
    },
    i18nMsg() {
      return this.$t("msg");
    }
  },
  watch: {
    deviceType(newVal, oldVal) {
      if (newVal === "mifi") {
        this.isMifi = true;
      } else {
        this.isCdb = true;
      }
    }
  },
  data() {
    return {
      isMifi: false,
      isCdb: false,
      deviceType: "cdb",
      wifiBoxData: null,
      rentCostShow: false,
      isLangView: false,
      cardList: []
    };
  },
  methods: {
    priceFormat(val) {
      if (val) {
        return val % 1 === 0 ? val : val.toFixed(2);
      }
      return val;
    },
    goRouterReplace(path) {
      this.$router.replace(path);
    },
    goRouter(path) {
      this.$router.push(path);
    },

    loadUser() {
      this.$get(
        USER_INFO,
        {},
        resp => {
          if (resp.user) {
            this.$store.commit("user", resp.user);
            this.onScan();
          } else {
            this.$store.commit("user", null);
          }
        },
        error => {
          this.$store.commit("user", null);
          console.log(error);
        }
      );
    }
  },
  created() {
    console.log(window.location.href);
    const { AppleIdToken } = this.$route.query;
    if (!this.user && AppleIdToken) {
      this.loginByApple(AppleIdToken, () => {
        this.$router.push("/");
      });
    }
  },
  mounted() {
    // this.getUserCardList()
  }
};
</script>

<style lang="less" scoped></style>
